// extracted by mini-css-extract-plugin
module.exports = {"project":"UserWidget_project__3JQiS","site_row":"UserWidget_site_row__2Ur3W","info":"UserWidget_info__i4LmT","img":"UserWidget_img__33lSy"};